import SVGIconWrapper from "./SVGIconWrapper"

const IconCaution = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 70 70"
        iconClass={`icon--caution ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <g transform="translate(0,-952.36218)">
            <path d="M35,952.4c-2,0-3.9,1-4.9,2.7L0.8,1004c-1,1.7-1,3.9,0,5.6c1,1.6,2.7,2.8,4.7,2.8h59c2,0,3.8-1.2,4.7-2.8 c1-1.7,1-3.9,0-5.6l-29.3-48.9C38.9,953.4,37,952.4,35,952.4z M35,956.4c0.6,0,1.2,0.4,1.5,0.8l29.3,48.9c0.2,0.4,0.2,1.1,0,1.5 c-0.3,0.6-0.7,0.8-1.3,0.8h-59c-0.6,0-0.9-0.3-1.3-0.8c-0.2-0.4-0.2-1.1,0-1.5l29.3-48.9C33.8,956.7,34.4,956.4,35,956.4z M35,968.4c-1.1,0-2,0.9-2,2v22c0,1.1,0.9,2,2,2s2-0.9,2-2v-22C37,969.3,36.1,968.4,35,968.4z M35,998.4c-1.7,0-3,1.3-3,3 c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C38,999.7,36.7,998.4,35,998.4z" />
        </g>
    </SVGIconWrapper>
)

export default IconCaution